import { render, staticRenderFns } from "./DataLoadXertify.vue?vue&type=template&id=71669025"
import script from "./DataLoadXertify.vue?vue&type=script&lang=js"
export * from "./DataLoadXertify.vue?vue&type=script&lang=js"
import style0 from "./DataLoadXertify.vue?vue&type=style&index=0&id=71669025&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports